<template>
  <modal name="submit-success-mobile-modal"
         class="submit-success-mobile-modal" height="391" width="354">
    <div class="submit-success-mobile-modal-header">
      <div class="header-image">
        <div class="sally-logo-light" />
        <div class="sally-logo-text-light" />
      </div>
    </div>
    <div class="submit-success-mobile-modal-body">
      <div class="message-conta0iner">
        <div>{{ $t('submit_success.content') }}</div>
        <br>
        <div>{{ $t('submit_success.thank') }}</div>
      </div>
    </div>
    <div class="submit-success-mobile-modal-footer">
      <button class="close-button" @click="hide">{{ $t('close') }}</button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'SubmitSuccessMobileModal',
  methods: {
    hide() {
      this.$modal.hide('submit-success-mobile-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/style/variable.scss';

.submit-success-mobile-modal {
  .submit-success-mobile-modal-header {
    display: flex;
    .header-image {
      margin: 61px auto 36px;
      display: flex;
      .sally-logo-light {
        width: 35px;
        height: 35px;
        background-size: 35px 35px;
        background-image: url('~@/assets/images/sally-logo-light.svg');
      }
      .sally-logo-text-light {
        width: 87px;
        height: 44px;
        background-size: 87px 44px;
        background-image: url('~@/assets/images/sally-logo-text-light.svg');
      }
      .sally-logo-light + .sally-logo-text-light{
        margin-left: 17px;
      }
    }
  }
  .submit-success-mobile-modal-body {
    .message-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      div {
        font-size: 16px;
        font-weight: 300;
        color: #2a324b;
      }
    }
  }
  .submit-success-mobile-modal-footer {
    margin-bottom: 60px;
    .close-button {
      margin: 36px auto 0px;
      display: flex;
      justify-content: center;
      width: 120px;
      height: 32px;
    }
  }
}
</style>
